import { Grid } from '@mui/material';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { FundingSources } from '~/modules/identification/forms/FinancialCondition/components/FundingSources.tsx';
import { styles } from '../styles.ts';
import FormGridItem from '~/components/FormComponents/FormGridItem';

export const BlockFinancialSoleTrader = () => {
  return (
    <Grid container spacing={3} sx={styles.wrapper}>
      <FormGridItem>
        <FormInput
          name="plannedMonthlyInflows"
          label={
            'Обсяг фінансових операцій (надходження коштів), які планує проводити клієнт протягом місяця по усіх рахунках (еквівалент в грн.) в АТ «Укрексімбанк»'
          }
          placeholder={'Введіть еквівалент в гривні'}
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name="prevYearTaxableIncome"
          label={`Сума загального оподатковуваного доходу, отриманого від провадження господарської діяльності/ незалежної професійної діяльності за попередній рік (еквівалент в грн.)`}
          placeholder={'Введіть еквівалент в гривні'}
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name="maxMonthlyInflows"
          label={
            'Максимальна сума фінансових операцій (надходження коштів) на місяць (еквівалент в грн.)'
          }
          placeholder={'Введіть еквівалент в гривні'}
          fullWidth
        />
      </FormGridItem>
      <FundingSources />
    </Grid>
  );
};
